module.exports = __webpack_public_path__ + "img/identity_3.3c66d328.jpg";